import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { JSONSchema6 } from "json-schema";
import { EField } from "./schema.followUpSms.types";

export const getSchema =
  (initialValues: { [key: string]: any }) =>
  (defaultValues: { [key: string]: any }): JSONSchema6 => ({
    required: [EField.SmsNumber, EField.SmsContent],
    properties: {
      [EField.SmsNumber]: {
        default: getValue(EField.SmsNumber, initialValues, defaultValues),
      },
      [EField.SmsContent]: {
        default: getValue(EField.SmsContent, initialValues, defaultValues),
        maxLength: 160,
      },
    },
  });

export const uiSchema = (): IUiSchema<EField> => ({
  [EField.SmsNumber]: {
    "ui:field": ERentioFormField.Text,
    title: getLocalizedText("payments.follow_up.sms.number.label"),
  },
  [EField.SmsContent]: {
    "ui:field": ERentioFormField.Text,
    title: getLocalizedText("payments.follow_up.sms.content.label"),
    multiline: true,
  },
});
